/* eslint-disable react/display-name */
import { SearchFacetType } from '../type';
import { dateRangeTag } from './tag';
import DateRangeFacetDetails from './DateRangeFacetDetails';
import makeCriteriaProvider from './makeCriteriaProvider';

const DateRangeFacet: SearchFacetType = {
  makeCriteriaProvider,
  tag: dateRangeTag,
  DetailsControl: DateRangeFacetDetails
};

export default DateRangeFacet;
export * from './DateRangeFacetDetails';
export * from './tag';
